import React from 'react';
import { uniqueId } from 'lodash-es';
import { AText } from '@alf/uikit';
import { ATextProps } from '@alf/uikit/src/components/AText';

type ScoreCellProps = {
  score: string;
  className: string;
} & ATextProps;

const ScoreCell = ({ score, className, ...props }: ScoreCellProps) => {
  return (
    <AText
      key={uniqueId('scoreCell_')}
      className={className}
      color="line_txt_1"
      size="m"
      {...props}
    >
      {score}
    </AText>
  );
};

export default ScoreCell;
